import { ReactNode } from "react";
import { Helmet } from "react-helmet";

interface Props {
  title?: string;
  children: ReactNode;
  fullScreen?: boolean;
}

const LoginLayout = ({ title, children, fullScreen = false }: Props) => {
  return (
    <>
    <div className="min-h-screen bg-white font-['Inter',sans-serif] text-slate-900">
      <Helmet>
        <title>{title ?? "Pagii Chatshop (CMS) - Login"}</title>
        <meta name="pagii" content="Pagii Chatshop" />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />

      </Helmet>
      <main
        className={`flex min-h-screen ${
          fullScreen ? "" : "items-center justify-center p-4"
        }`}
      >
        {children}
      </main>
    </div>
    </>
  );
};

export default LoginLayout;
